import { makeStyles } from '@mui/styles';

export const useNewCustomerButtonStyles = makeStyles({
  card: {
    height: '48px',
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #CCCCCC',
    borderRadius: '5px',
    cursor: 'pointer'
  }
});
